import { render, staticRenderFns } from "./ExcluirModal.vue?vue&type=template&id=30d36ca9&scoped=true"
import script from "./ExcluirModal.vue?vue&type=script&lang=js"
export * from "./ExcluirModal.vue?vue&type=script&lang=js"
import style0 from "./ExcluirModal.vue?vue&type=style&index=0&id=30d36ca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d36ca9",
  null
  
)

export default component.exports